<template>
  <!-- Mobile: icon button + label below -->
  <div v-if="isMobile" :key="label" class="flex flex-col gap-2 flex-none">
    <Button
      class="!rounded-2xl !w-12 !h-12 !flex-none"
      :icon="`pi ${icon}`"
      iconClass="!text-xl"
      :pt="{
            root: {class: `${icon === 'pi-trash' ? '!bg-red-400': '!bg-[#b798f5]'} !border-none hover:bg-[#A785EF]`}
          }"
      @click="onClick"
    />
    <span class="text-sm whitespace-pre-line text-center" style="line-height: 1rem">{{ label }}</span>
  </div>
  <!-- Desktop: rounded button with label -->
  <Button
    v-else
    class="flex-none"
    :label="desktopLabel"
    rounded
    :outlined="!isPrimary"
    @click="onClick"
    :icon="`pi ${icon}`"
  />
</template>

<script setup lang="ts">
import { useResponsive } from '@app/composables/responsive';

const props = defineProps({
  label: {
    required: true,
    type: String
  },
  icon: {
    required: true,
    type: String
  },
  desktopLabel: {
    type: String,
    default: ''
  },
  isPrimary: {
    type: Boolean,
    default: false
  },

});
const emit = defineEmits(['action'])
const { isMobile } = useResponsive();

const onClick = () => {
  emit('action')
}

</script>

